import api from "../index";

export const GetDashboardApi = (userId) => api.get(`UserMaster/User-DashboardById`);
export const GetEarningApi = (loginId, params) => api.get(`UserMaster/MyEarningZone-ByLoginId/${loginId}?${params}`);
export const GetTradeZoneApi = (loginId, params) => api.get(`UserMaster/MyTradeZone-ByLoginId/${loginId}?${params}`);
export const SendIBRequestApi = (data) => api.post('UserMaster/User-IBRequest', data);
export const GetIBRequestStatusApi = (userId) => api.get(`IBMaster/Check-IBRequest-Status`);
export const YourWallet = (userId) => api.get(`WalletMaster/Get-WalletDetails/${userId}`);